<div class="confirmation">
  <p class="confirmation-message">Please reload the page. There might be updates in system</p>
  <button class="btn btn-primary gdpr-confirmation-btn" (click)="onConfirm()">RELOAD</button>
</div>
